import * as React from 'react';
import * as fp from 'lodash/fp';
import connectToStorage from 'modules/utils/connectToStorage';
import noData from 'modules/utilities/noData';

const YourSelectedSize = ({previouslySelectedTireSize}) =>
    <span className="crux-body-copy">
        Your previously selected tire size is:
        {' '}
        <span className="crux-color-good-bg crux-black crux-body-copy crux-body-copy--bold">{previouslySelectedTireSize}</span>
    </span>;

export default fp.flowRight(
    connectToStorage('previouslySelectedTireSize', false),
    noData(({previouslySelectedTireSize}) => !previouslySelectedTireSize, fp.F)
)(YourSelectedSize)




// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/tires/YourSelectedSize.tsx